export const getApplePayOrderSummary = (order: {
  shipments: Array<{
    selectedShippingOption: null | {
      cost: number
    }
  }>
  subtotal: number
  taxTotal: number
  totalDiscount: number
  cart: {
    coupons: Array<{
      code: string
      discountedAmount: number
    }>
  }
}): ApplePayJS.ApplePayLineItem[] => {
  const shippingCosts = order.shipments[0]?.selectedShippingOption?.cost
  const lineItems: ApplePayJS.ApplePayLineItem[] = [
    {
      label: 'Subtotal',
      type: 'final',
      amount: String(order.subtotal),
    },
  ]
  if (shippingCosts) {
    lineItems.push({
      label: 'Shipping & Delivery:',
      type: 'final',
      amount: String(shippingCosts),
    })
  }
  lineItems.push({
    label: 'Tax',
    type: 'final',
    amount: String(order.taxTotal),
  })
  if (order.cart.coupons.length) {
    const couponCodes = order.cart.coupons.map((coupon) => coupon.code)
    const toalCouponDiscount = (
      order.cart.coupons.reduce((acc, coupon) => acc + coupon.discountedAmount, 0)
    )
    lineItems.push({
      label: `Promo: ${couponCodes.join(' + ')}`,
      type: 'final',
      amount: `${Math.abs(toalCouponDiscount) * -1}`,
    })
  }
  if (order.totalDiscount) {
    lineItems.push({
      label: 'You saved',
      type: 'final',
      amount: String(order.totalDiscount),
    })
  }
  return lineItems
}

export default getApplePayOrderSummary
